import { render, staticRenderFns } from "./ModalBadges.vue?vue&type=template&id=2ddae656&scoped=true"
import script from "./ModalBadges.vue?vue&type=script&lang=js"
export * from "./ModalBadges.vue?vue&type=script&lang=js"
import style0 from "./ModalBadges.vue?vue&type=style&index=0&id=2ddae656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddae656",
  null
  
)

export default component.exports